import React from 'react'
import { SecurityQuestions } from './SecurityQuestions'
import { useSelfSignupWithSecretLinkMutation } from './SecurityQuestions.codegen'
import { AllowedUserFieldsEnum } from 'shared/accountNameConfig'
import { useLoginContext } from '../login/LoginContext'
import { observer } from 'mobx-react-lite'

export const useSignupWithLink = () => {
  const ctx = useLoginContext()
  const [fetch] = useSelfSignupWithSecretLinkMutation()

  return async (): Promise<boolean> => {
    const userIdentifier = {}
    if (ctx.isAccountNameLoginOn) {
      userIdentifier[AllowedUserFieldsEnum.ACCOUNT_NAME] =
        ctx.additionalData[AllowedUserFieldsEnum.ACCOUNT_NAME]
    } else {
      userIdentifier[AllowedUserFieldsEnum.EMAIL] =
        ctx.additionalData[AllowedUserFieldsEnum.EMAIL]
    }

    const { data } = await fetch({
      variables: {
        token: ctx.selfSignupToken,
        userInput: {
          ...ctx.pickUserAdditionalData(),
          ...userIdentifier,
          password: ctx.password
        },
        securityQuestions: ctx.securityQuestions
      }
    })

    return !!data?.organisation?.secretSelfSignupLink?.signUp?.id
  }
}

export const AskSecurityQuestionsAndSignUpWithSecretLinkStep: React.FC =
  observer(() => {
    const signupWithLink = useSignupWithLink()
    const submit = () => signupWithLink()

    return <SecurityQuestions submit={submit} />
  })

AskSecurityQuestionsAndSignUpWithSecretLinkStep.displayName =
  'AskSecurityQuestionsAndSignUpWithSecretLinkStep'
